import { createStore } from 'vuex'

export default createStore({
  state: {
    isMobile: false,
    menus: []
  },
  mutations: {
    setIsMobile(state, value) {
      state.isMobile = value
    }
  },
  actions: {
    updateIsMobile({ commit }, value) {
      commit('setIsMobile', value)
    }
  },
  getters: {
    isMobile: state => state.isMobile
  }
})